<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  sectionKey: { type: String, required: true },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  icon: { type: String, default: 'i-lucide-circle' },
});

const emit = defineEmits(['viewed']);
const sectionRef = ref(null);
let observer = null;
let viewed = false;

const markViewed = () => {
  if (viewed) return;
  viewed = true;
  emit('viewed', props.sectionKey);
  observer?.disconnect();
};

onMounted(() => {
  if (typeof IntersectionObserver === 'undefined' || !sectionRef.value) {
    markViewed();
    return;
  }

  observer = new IntersectionObserver(
    entries => {
      if (entries.some(entry => entry.isIntersecting)) markViewed();
    },
    { threshold: 0.35 }
  );
  observer.observe(sectionRef.value);
});

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
  <section
    :id="`pricing-report-section-${sectionKey}`"
    ref="sectionRef"
    class="rounded-lais border border-lais-border-soft bg-white p-4"
  >
    <div class="flex items-start gap-3">
      <span
        class="grid size-9 shrink-0 place-items-center rounded-full bg-lais-primary-50 text-lais-primary"
      >
        <span class="size-4" :class="icon" aria-hidden="true" />
      </span>
      <div class="min-w-0">
        <h3 class="text-[16px] font-semibold text-lais-text font-redHatDisplay">
          {{ title }}
        </h3>
        <p v-if="subtitle" class="mt-1 text-[13px] text-lais-text-muted">
          {{ subtitle }}
        </p>
      </div>
    </div>
    <div class="mt-4">
      <slot />
    </div>
  </section>
</template>
